export const mainColor = '#0050ffcc';
export const liteMainColor = '#dee6f0';
export const mainTextColor = '#0050ffe6';
export const EditOutlineColor = '#0050ffb3';
export const darkBlue = '#17375D';
export const salesMainColor = '#ffc000';
export const brokerBlack = '#000';
export const brokerGray = '#e9e9e9';
export const backColor = '#62646d';
